import { useState, useEffect, useMemo } from 'react';
import { fitBounds } from 'google-map-react/utils';
// import { sizes } from '../../styles/breakpoint';

const defaultMapCoordinates = {
  sw: {
    lat: '34.90253098954486',
    lng: '-90.43729390492535'
  },
  ne: {
    lat: '35.39032338025625',
    lng: '-89.26065817950166'
  }
};

export const calculateDistance = (lat1, lon1, lat2, lon2, unit) => {
  if (lat1 === lat2 && lon1 === lon2) {
    return 0;
  }
  const radlat1 = (Math.PI * lat1) / 180;
  const radlat2 = (Math.PI * lat2) / 180;
  const theta = lon1 - lon2;
  const radtheta = (Math.PI * theta) / 180;
  let dist = Math.sin(radlat1) * Math.sin(radlat2)
    + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  if (dist > 1) {
    dist = 1;
  }
  dist = Math.acos(dist);
  dist = (dist * 180) / Math.PI;
  dist = dist * 60 * 1.1515;
  if (unit === 'K') {
    dist *= 1.609344;
  }
  if (unit === 'N') {
    dist *= 0.8684;
  }
  return dist;
};

const getBoundsFromCoordinates = (list, maps) => {
  var bounds = new maps.LatLngBounds();

  list.forEach((l) => {
      var latLng = new maps.LatLng(l['lat'], l['lng']);
      bounds.extend(latLng);
  });

if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
  var extendPoint1 = new maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
  var extendPoint2 = new maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
  bounds.extend(extendPoint1);
  bounds.extend(extendPoint2);
}
  return bounds;
}

export const useHandleBounds = () => {
  const [center, setCenter] = useState({ lat: 35.072872, lng: -89.8469893 });
  const [zoom, setZoom] = useState(10);
  const windowWidth = (window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth)*.5;
    const windowHeight = (window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight)*.5;

  const updateBounds = useMemo(
    () => (listings, maps, map) => {
      const geoCodedListings = listings && listings.filter((x) => x.geoCode && withinBounds(x.geoCode));
      const geoCodes = geoCodedListings && geoCodedListings.map(({ geoCode }) => ({
        lat: geoCode.latitude,
        lng: geoCode.longitude,
      }));

      if (geoCodes && geoCodes.length > 0) {
        const bounds = getBoundsFromCoordinates(geoCodes, maps);
        map.fitBounds(bounds);
      }


      // const { center: boundsCenter, zoom: boundsZoom } = fitBounds(
      //   bounds,
      //   size
      // );
      // setCenter(boundsCenter);
      // setZoom(boundsZoom);
    },
    []
  );

  // const updateBounds = () => null;
  return [center, setCenter, zoom, setZoom, updateBounds];
};

export const useHandleMobileWidth = (listings) => {
  const [showMap, setShowMap] = useState(false);
  const windowWidth = window.innerWidth
    || document.documentElement.clientWidth
    || document.body.clientWidth;
  const [isMobile, setIsMobile] = useState(true);

  const sizes = {
    tablet: 641,
    desktop: 1024,
  };

  // Only show map either on desktop or when requested by user
  useEffect(() => {
    const setDeviceSpecificStates = () => {
      if (windowWidth > sizes.tablet) {
        setIsMobile(false);
      } else if (windowWidth <= sizes.tablet) {
        setIsMobile(true);
        setShowMap(true);
      }
    };

    setDeviceSpecificStates();

    const handleResize = () => {
      setDeviceSpecificStates();
    };

    let resizeTimer;
    window.addEventListener('resize', () => {
      // Simple debounce
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        handleResize();
      }, 200);
    });

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [sizes.tablet, windowWidth]);

  return [isMobile, showMap, setShowMap];
};

const arePointsNear = function(checkPoint, centerPoint, km) {
  const ky = 40000 / 360;
  const kx = Math.cos((Math.PI * centerPoint.lat) / 180.0) * ky;
  const dx = Math.abs(centerPoint.lng - checkPoint.lng) * kx;
  const dy = Math.abs(centerPoint.lat - checkPoint.lat) * ky;
  return Math.sqrt(dx * dx + dy * dy) <= km;
};

export const withinBounds = ({ latitude, longitude }) => {
  const position = { lat: latitude, lng: longitude };
  return arePointsNear(
    position,
    { lat: 35.1467926522085, lng: -89.84897604221354 },
    32
  );
};
